import { render, staticRenderFns } from "./FurnishedObjects.vue?vue&type=template&id=67b6e2ef&scoped=true&"
import script from "./FurnishedObjects.vue?vue&type=script&lang=ts&"
export * from "./FurnishedObjects.vue?vue&type=script&lang=ts&"
import style0 from "./FurnishedObjects.vue?vue&type=style&index=0&id=67b6e2ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6e2ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField})
